import {
  SET_WEAKNESSES,
  ADD_WEAKNESS,
  PUT_WEAKNESS,
  DELETE_WEAKNESS,
  SET_RISK_WEAKNESSES,
  SET_INFINITE_WEAKNESSES,
  SET_SEARCHED_WEAKNESSES,
} from "../types/weaknessesTypes";

const initialState = {
  all: [],
  selected: null,
  totalPages: 0,
  sources: [],
  riskWeaknesses: [],
  infiniteWeaknesses: [],
};

const weaknessesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WEAKNESSES:
      return {
        ...state,
        all: action.payload.items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
      };
    case SET_INFINITE_WEAKNESSES:
      return {
        ...state,
        infiniteWeaknesses: [
          ...state.infiniteWeaknesses,
          ...action.payload.items,
        ],
        totalPages: action.payload.totalPages,
      };
    case SET_SEARCHED_WEAKNESSES:
      return {
        ...state,
        infiniteWeaknesses: action.payload.items,
        totalPages: action.payload.totalPages,
      };
    case SET_RISK_WEAKNESSES:
      return {
        ...state,
        riskWeaknesses: action.payload,
      };
    case ADD_WEAKNESS:
      return { ...state, all: [...state.all, action.payload] };
    case PUT_WEAKNESS:
      return {
        ...state,
        all: state.all.map((item) =>
          item.id === action.payload.id
            ? { ...item, ...action.payload.data }
            : item
        ),
      };
    case DELETE_WEAKNESS:
      return {
        ...state,
        all: state.all.filter((item) => item.id !== action.payload),
      };

    default:
      return state;
  }
};

export default weaknessesReducer;
